import pagination from '@iso/lib/helpers/pagination';
import create from './create/model';
import deleteModel from './delete/model';

export default {
    ...pagination('promotionDurationList').model,
    create,
    delete: deleteModel,

};